import { useMutation } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { ISelectOption } from '@widgets/multi-select';
import { BI_BASE_URL } from '@app/contstants/endpoints';

interface ISourceFilter {
  name: string;
}

// Hidden catalog values are offered only in filters (to find old records), not in selection forms.
export const fetchData = async (includeHidden = false): Promise<ISelectOption[]> => {
  const response = await api.get<ISourceFilter[]>(`${BI_BASE_URL}/helpers/search/sources/`, {
    params: includeHidden ? { include_hidden: true } : undefined,
  });
  const data = response.data ?? [];

  return data.map(item => ({
    value: `${item.name}`,
    label: item.name,
  }));
};

export const useSourceOptions = ({ includeHidden = false }: { includeHidden?: boolean } = {}) => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: () => fetchData(includeHidden),
    onError: error => errorHandler(error),
  });

  return {
    fetchData: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
